export const LOAD_TERMS = 'LOAD_TERMS';
export const SET_TERMS = 'SET_TERMS';

export interface LoadTermsAction {
  type: typeof LOAD_TERMS;
}

export interface SetTermsAction {
  type: typeof SET_TERMS;
  payload: { data: string };
}

export type TermsActionTypes = LoadTermsAction | SetTermsAction;
